import { http, httpFile } from './http_service';
//Get Single
export function single(id){
  return http().get(`/logs/single/${id}`);
}
